import React from 'react';
import { number } from 'prop-types';

import { decimalFormat, formatPercentage } from '@ajaibid/utils';
import { Typography } from '@ajaibid/components';

import { getTickerStyle } from './helpers';

const PortfolioReturnTicker = (props) => {
  const { change, percentage, ...rest } = props;

  const { color } = getTickerStyle(change);

  return (
    <Typography type="label" size="xs" color={color} margin={0} {...rest}>
      {decimalFormat(change)}
      &nbsp;
      {formatPercentage(percentage, 2, { bracket: true, sign: true })}
    </Typography>
  );
};

PortfolioReturnTicker.propTypes = {
  change: number,
  percentage: number,
};

PortfolioReturnTicker.defaultProps = {
  change: 0,
  percentage: 0,
};

export default PortfolioReturnTicker;
